import { type FC } from 'react';
import { useHomePageContext } from '../HomePageContext.tsx';
import { getBillboardAdData } from 'dibs-google-ad-manager/exports/adHelpers.ts';
import { BillboardBannerAd } from 'dibs-google-ad-manager/exports/BillboardBannerAd.ts';
import { type AdBillboardPlacement } from 'dibs-google-ad-manager/exports/types.ts';

import classNames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    placement: AdBillboardPlacement;
};

export const HpSharedBillboardAd: FC<Props> = ({ placement }) => {
    const { isDesktop } = useHomePageContext();
    // Tablet should get mobile ad
    const adWidth = isDesktop ? 'desktop' : 'mobile';
    const billboardAdData = getBillboardAdData(placement)?.[adWidth];

    if (!billboardAdData) {
        return null;
    }

    const isHomeBottomPlacement = placement === 'home-bottom';

    return (
        <BillboardBannerAd
            {...billboardAdData}
            lazyLoad={isHomeBottomPlacement}
            className={classNames({
                [dibsCss.mtSmaller]: isHomeBottomPlacement,
                [dibsCss.mbMedium]: !isHomeBottomPlacement || !isDesktop,
            })}
        />
    );
};
